import { API_BASE_URL, requestJson } from "./apiClient";

let partnerVendorDirectoryClientViewId = null;

export function enablePartnerVendorDirectoryApi(clientViewId) {
  partnerVendorDirectoryClientViewId = clientViewId || null;
}

export function disablePartnerVendorDirectoryApi() {
  partnerVendorDirectoryClientViewId = null;
}

export function isPartnerVendorDirectoryApiEnabled() {
  return Boolean(partnerVendorDirectoryClientViewId);
}

export function resolveVendorDirectoryApiBase(clientViewId) {
  const viewId = partnerVendorDirectoryClientViewId || clientViewId;
  if (partnerVendorDirectoryClientViewId) {
    return `${API_BASE_URL}/api/partner/casamapa/vendor-directory/views/${viewId}/servicios`;
  }
  return `${API_BASE_URL}/api/client/views/${viewId}/servicios`;
}

export async function clientPortalRequest(path, options = {}) {
  if (partnerVendorDirectoryClientViewId) {
    const normalized = path.startsWith("/api")
      ? path.replace(/^\/api\/client/, "")
      : path;

    const isServiciosPath = /\/views\/[^/]+\/servicios(?:\/|$)/.test(normalized);
    if (isServiciosPath) {
      const partnerPath = `/api/partner/casamapa/vendor-directory/views/${partnerVendorDirectoryClientViewId}/servicios${normalized.replace(/^\/views\/[^/]+\/servicios/, "")}`;
      return requestJson(partnerPath, {
        ...options,
        skipAuthRedirect: true,
      });
    }
  }

  return requestJson(path.startsWith("/api") ? path : `/api/client${path}`, {
    ...options,
    skipAuthRedirect: true,
  });
}

export function buildClientQuery(params) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      search.set(key, String(value));
    }
  });
  const query = search.toString();
  return query ? `?${query}` : "";
}

export { API_BASE_URL };
